import React from 'react';

const MissionSection = () => {
  return (
    <section id="mission" className="mission">
      <h2 style={{fontSize: 30}}>Our Mission</h2>
      <p  style={{fontSize: 20}}>
        Maths Gem Seychelles empowers students to master mathematics in Creole, learning at their own pace anytime, anywhere.
      </p>
    </section>
  );
};

export default MissionSection;